/**
 * Will be true when a left panel of the TopBar is opened
 *
 * - Compass
 * - Tag Navigator
 */
export const isTopBarLeftPanelOpened = ref(false)

/**
 * Will be true when a right panel of the TopBar is opened
 *
 * - Drive
 * - Notif
 */
export const isTopBarRightPanelOpened = ref(false)

/**
 * Is the tagger app opened in the left panel from topbar?
 */
export const isTaggerAppOpenedInLeftPanel = ref(false)
/**
 * Will be true when the legal data are fetched
 */
export const isLegalInfoFetched = ref(false)
